// extracted by mini-css-extract-plugin
export default {"limitOptions":"LimitOptions_limitOptions__PSzcD","editIcon":"LimitOptions_editIcon__P6osD","tooltip":"LimitOptions_tooltip__eq5Qa"};